import { Injectable } from '@angular/core';
import moment from 'moment';

import { DateFormatService } from './date-format.service';

@Injectable()
export class MomentService {
  constructor(private dateFormatService: DateFormatService) {}

  monthStart(date?: any) {
    return moment(date).startOf('month').toDate();
  }

  monthEnd(date?: any) {
    return moment(date).endOf('month').toDate();
  }

  yearStart(date?: any) {
    return moment(date).startOf('year').toDate();
  }

  yearEnd(date?: any) {
    return moment(date).endOf('year').toDate();
  }

  dateStart(date: any) {
    return moment(date).startOf('date');
  }

  toDate(value: any) {
    return moment(value).toDate();
  }

  toDateStart(value: any) {
    return moment(value).startOf('date').toDate();
  }
  toDateEnd(value: any) {
    return moment(value).endOf('date').toDate();
  }

  formatDate(value: any, format: string) {
    return moment(value).format(format);
  }

  formatDateWithoutTime(value: any) {
    return `${moment(value).format('YYYY-MM-DD')}T00:00:00.000Z`;
  }

  addMonths(value: any, amount: number) {
    return moment(value).add(amount, 'M').toDate();
  }

  addDays(value: any, amount: number) {
    return moment(value).add(amount, 'd').toDate();
  }

  thisMonth() {
    return [
      moment().startOf('month').toDate(),
      moment().endOf('month').toDate()
    ];
  }

  thisQuarter() {
    return [
      moment().startOf('quarter').toDate(),
      moment().endOf('quarter').toDate()
    ];
  }

  thisYear() {
    return [moment().startOf('year').toDate(), moment().endOf('year').toDate()];
  }

  lastMonth() {
    return [
      moment().add(-1, 'M').startOf('month').toDate(),
      moment().add(-1, 'M').endOf('month').toDate()
    ];
  }

  past3Months() {
    return [
      moment().add(-3, 'M').startOf('month').toDate(),
      moment().add(-1, 'M').endOf('month').toDate()
    ];
  }

  past6Months() {
    return [
      moment().add(-6, 'M').startOf('month').toDate(),
      moment().add(-1, 'M').endOf('month').toDate()
    ];
  }

  moment(date: any = null) {
    if (date) return moment(date);
    return moment();
  }

  /** Parse with format(s) and optional strict mode. Returns moment object. */
  parseWithFormats(value: any, formats: string | string[], strict?: boolean) {
    return moment(value, formats, strict);
  }

  get dateFormat() {
    return this.dateFormatService.currentDateFormatValue;
  }
}
